import { get } from '.';

export function GetTicketFlags() {
	return get<any>('/app/api/ticket_flags');
}